'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tile = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _markdown = require('helpers/markdown');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = require('constants/icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_POSITIONS = ['top', 'left', 'left-center'];
var ICON_SRC_BY_NAME = (0, _extends3.default)({}, _icons.NUMBER_ICONS, _icons.CIRCLE_ICONS, _icons.TILE_ICONS);

var Tile = exports.Tile = function (_PureComponent) {
  (0, _inherits3.default)(Tile, _PureComponent);

  function Tile() {
    (0, _classCallCheck3.default)(this, Tile);
    return (0, _possibleConstructorReturn3.default)(this, (Tile.__proto__ || (0, _getPrototypeOf2.default)(Tile)).apply(this, arguments));
  }

  (0, _createClass3.default)(Tile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          description = _props.description,
          icon = _props.icon,
          iconPosition = _props.iconPosition,
          title = _props.title;

      var src = ICON_SRC_BY_NAME[icon];
      var tileClassName = (0, _classnames2.default)((0, _defineProperty3.default)({
        Tile: true
      }, 'Tile--position-' + iconPosition, ICON_POSITIONS.includes(iconPosition)));

      return _react2.default.createElement(
        'div',
        { className: tileClassName },
        src && _react2.default.createElement(_reactInlinesvg2.default, { className: 'Tile__icon', src: src }),
        _react2.default.createElement(
          'div',
          { className: 'Tile__content' },
          title && _react2.default.createElement(
            'h3',
            { className: 'Tile__title' },
            title
          ),
          _react2.default.createElement(
            'p',
            { className: 'Tile__description' },
            (0, _markdown.renderMarkdown)(description)
          )
        )
      );
    }
  }]);
  return Tile;
}(_react.PureComponent);

Tile.defaultProps = {
  iconPosition: 'top'
};

Tile.propTypes = {
  description: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.oneOf((0, _keys2.default)(ICON_SRC_BY_NAME)),
  iconPosition: _propTypes2.default.oneOf(ICON_POSITIONS),
  title: _propTypes2.default.string
};